// extracted by mini-css-extract-plugin
export default {"panel":"MultipleSelect_panel__IpAGJ","search":"MultipleSelect_search__251OD","options":"MultipleSelect_options__YXUE8"};